"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _form = require("@clayui/form");
var _react = _interopRequireDefault(require("react"));
var _excluded = ["ariaLabel", "inputName", "useNative", "value"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var ClayDatePickerInputDate = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
    _ref$inputName = _ref.inputName,
    inputName = _ref$inputName === void 0 ? 'datePicker' : _ref$inputName,
    _ref$useNative = _ref.useNative,
    useNative = _ref$useNative === void 0 ? false : _ref$useNative,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    name: inputName,
    type: "hidden",
    value: value
  }), /*#__PURE__*/_react.default.createElement(_form.ClayInput, _extends({}, otherProps, {
    "aria-label": ariaLabel,
    insetAfter: !useNative,
    ref: ref,
    type: useNative ? 'date' : 'text',
    value: value
  })));
});
ClayDatePickerInputDate.displayName = 'ClayDatePickerInputDate';
var _default = exports.default = ClayDatePickerInputDate;